module.exports = __webpack_public_path__ + "static/media/oak.62cdfe7f.png";